// https://glamdigitallab.atlassian.net/browse/JC-727 Salesforce injects the chat launcher as a
// role="button" element that ignores Space. Capture phase, to win over the vendor handler.
(function () {
  var LAUNCHER_SELECTOR = [
    '.embeddedServiceHelpButton .helpButton',
    '.embeddedServiceHelpButton .uiButton',
    '.helpButtonEnabled'
  ].join(', ');

  function isSpaceKey(event) {
    // `code` is the fallback for older Safari
    return event.key === ' ' || event.key === 'Spacebar' || event.code === 'Space';
  }

  document.addEventListener(
    'keydown',
    function (event) {
      if (!isSpaceKey(event)) return;
      if (event.altKey || event.ctrlKey || event.metaKey) return;
      if (!event.target || typeof event.target.closest !== 'function') return;

      var launcher = event.target.closest(LAUNCHER_SELECTOR);
      if (!launcher) return;

      // stop the page scroll and the vendor handler
      event.preventDefault();
      event.stopPropagation();

      launcher.click();
    },
    true
  );
})();
